export const standardBoxSpring = {
  from: { opacity: 0, y: 20 },
  to: { opacity: 1, y: 0 },
  config: { tension: 280, friction: 20, mass: 1 },
}
